import { Device } from "@app/shared/src/models";

/**
 * What a truck is called on screen.
 *
 * A location in Fleet Commander is one TMA truck holding one device, and it is the *location*
 * customers name — "TMA-87979" — not the device row underneath it. So the site name is the
 * identity a director recognises on a list; the device's own name is only a fallback for a unit
 * that has not been attached to a location yet.
 *
 * Paired with the device key everywhere it appears: two trucks can carry the same TMA number
 * across a swap, and the key on the unit's label is what settles which box you are looking at.
 */
export const siteLabel = (device?: Device): string => device?.facilityName || device?.name || "—";
